import { render, staticRenderFns } from "./TabPrecificacaoGrupo.vue?vue&type=template&id=1b733a1a&"
import script from "./TabPrecificacaoGrupo.vue?vue&type=script&lang=js&"
export * from "./TabPrecificacaoGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports